import React from "react";
import { Box } from "@mui/material";
import FileUploadBox from "./FileUploadBox";

const DocumentsUploadStep = ({ fileData, handleFiles, idType }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4, flex: 1 }}>
      <FileUploadBox
        label="DIRECTOR'S / OWNER'S ID COPY"
        required
        sublabel="Upload a clear copy of ID of all directors or owners. Multiple files accepted."
        multiple
        files={fileData.directorFiles}
        onChange={(files) => handleFiles("directorFiles", files)}
      />
      {idType === "companyRegNo" && (
        <FileUploadBox
          label="VAT REGISTRATION COPY"
          required
          sublabel="Upload a clear copy of the VAT registration document."
          multiple={false}
          files={fileData.idVatFiles}
          onChange={(files) => handleFiles("idVatFiles", files)}
        />
      )}
    </Box>
  );
};

export default DocumentsUploadStep;
